import {
    FETCH_BAS_TYPES,
    FETCH_PROFILES,
    PROFILE_REMOVE,
    PROFILE_REORDER,
    PROFILE_TOGGLE_SELECT,
    PROFILE_UPDATE,
    SET_PROFILE
} from '../actions/actionTypes';

import { patchItem, removeItem } from '../helpers/collections';

const initialState = {
    basTypes:          [],
    order:             'asc',
    orderBy:           'name',
    profiles:          [],
    selectedProfileId: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_BAS_TYPES:
            return {
                ...state,
                basTypes: [...action.payload]
            };
        case FETCH_PROFILES:
            return {
                ...state,
                profiles: [...action.payload]
            };
        case PROFILE_REMOVE:
            return {
                ...state,
                profiles: removeItem(state.profiles, action.payload.id)
            };
        case PROFILE_REORDER:
            return {
                ...state,
                order:   action.payload.order,
                orderBy: action.payload.orderBy
            };
        case PROFILE_TOGGLE_SELECT:
            return {
                ...state,
                profiles: patchItem(
                    state.profiles,
                    action.payload.id,
                    ({ isSelected }) => ({
                        isSelected: !isSelected
                    })
                )
            };
        case PROFILE_UPDATE:
            return {
                ...state,
                profiles: patchItem(
                    state.profiles,
                    action.payload.id,
                    action.payload.patch
                )
            };
        case SET_PROFILE: {
            let selectedProfileId = null;
            if (action.payload) {
                selectedProfileId = action.payload.id;
            }
            return {
                ...state,
                selectedProfileId
            };
        }
        default:
            return state;
    }
};
